export enum AesStatus {
  New = 'N',
  Accepted = 'A',
  Rejected = 'R',
  Transmitted = 'X',
  Deleted = 'D',
  Error = 'Error',
  Canceled = 'C',
  Pending = 'P'
}

export enum AesAction {
  None = 'N',
  Add = 'A',
  Replace = 'R',
  Change = 'C',
  Delete = 'D',
  Cancel = 'X',
  Template = 'T'
}

export enum MotType {
  VesselNonContainerized = 10,
  VesselContainerzied = 11,
  Barge = 12,
  Rail = 20,
  RailContainerized = 21,
  Truck = 30,
  TruckContainerized = 31,
  Auto = 32,
  Pedstrian = 33,
  RoadOther = 34,
  Air = 40,
  AirContainerized = 41,
  Mail = 50,
  PassengerHandCarried = 60,
  FixedTransportInstallations = 70,
}

export const MotItems = [
  { value: MotType.VesselNonContainerized, label: 'Vessel, Non-containerized' },
  { value: MotType.VesselContainerzied, label: 'Vessel, Containerized' },
  { value: MotType.Barge, label: 'Barge' },
  { value: MotType.Rail, label: 'Rail' },
  { value: MotType.RailContainerized, label: 'Rail, Containerized' },
  { value: MotType.Truck, label: 'Truck' },
  { value: MotType.TruckContainerized, label: 'Truck, Containerized' },
  { value: MotType.Auto, label: 'Auto' },
  { value: MotType.Pedstrian, label: 'Pedestrian' },
  { value: MotType.RoadOther, label: 'Road, Other' },
  { value: MotType.Air, label: 'Air' },
  { value: MotType.AirContainerized, label: 'Air, Containerized' },
  { value: MotType.Mail, label: 'Mail' },
  { value: MotType.PassengerHandCarried, label: 'Passenger, Hand-carried' },
  { value: MotType.FixedTransportInstallations, label: 'Fixed Transport Installations' },
];

const Severity = {
  Fatally: { value: 'F', label: 'Fatally' },
  Warning: { value: 'W', label: 'Warning' },
  Verification: { value: 'V', label: 'Verification' },
  Compliance: { value: 'C', label: 'Compliance' },
  Information: { value: 'I', label: 'Information' }
} as const;

export const SeverityValueToLabel = Object.values(Severity).reduce((acc, item) => {
  acc[item.value] = item.label;
  return acc;
}, {} as Record<string, string>);
